import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  searchInput: {
    color: theme.palette.text.primary,
    // padding: '8px 0 8px 15px',
    // '&::placeholder': {
    //   color: theme.palette.primary.main,
    //   opacity: 1
    // }
  },
  searchRoot: {
    backgroundColor: '#FFF',
    paddingTop: '5.5px!important',
    paddingBottom: '4.5px!important',
    marginBottom: 0,
    '& .MuiAutocomplete-popupIndicatorOpen': {
      transform: 'none'
    }
  },
  searchNotchedOutline: {
    border: 'none',
    borderRadius: 10
  },
  searchButton: {
    padding: 0,
    '& svg': {
      fill: theme.palette.primary.main
    }
  },
  autocompleteRoot: {
    width: 512,
    position: 'absolute',
    zIndex: 5,
    top: 0,
    right: 0,
    '& .MuiFormControl-root': {
      marginTop: 0,
      marginBottom: 0
    }
  },
  popper: {
    backgroundColor: '#FFF',
    paddingTop: 0,
    paddingBottom: 0,
    borderRadius: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    filter: 'drop-shadow(0px 12px 48px rgba(0, 0, 0, 0.1))',
    zIndex: 1101
  },
  popperDivider: {
    backgroundColor: 'rgba(143,146,161,0.15)',
    height: '1px',
    marginTop: 0,
    marginBottom: 0
  },
  popperActionContainer: {
    paddingLeft: 0,
    paddingRigth: 0,
    textAlign: 'left',
    paddingBottom: 8
  },
  popperAction: {
    width: '100%',
    textAlign: 'left',
    justifyContent: 'flex-start',
    marginBottom: 0
  },
  paper: {
    paddingLeft: 0,
    paddingRigth: 12,
    zIndex: 4,
    '& ul li': {
      borderRadius: '8px'
    }
  },
  searchRootOpen: {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottom: '1px solid rgba(143,146,161,0.15)'
  },
  newAdviceButton: {
    position: 'relative',
    paddingLeft: 30,
    paddingRight: 30,
    marginBottom: 0
  },
  invisible: {
    display: 'none'
  },
  buttonIcon: {
    width: 16,
    height: 16,
    marginLeft: 8,
    fill: '#FFF'
  },
  option: {
    display: 'flex',
    alignItems: 'center'
  },
  optionIcon: {
    flexShrink: 0,
    width: 16,
    height: 16,
    marginRight: 8
  },
  searchIcon: {
    fill: '#A8A8A8'
  }
}))

export default useStyles
